<template>
  <div class="article-tab" :style="componentStyle">
    <div class="box-header">
      <div class="box-tabbar">
        <div
          class="item"
          :class="{ active: index === activeTab }"
          :key="index"
          v-for="(item, index) in value.tabs"
          @click="handleToggleTab(index)"
        >
          <span class="name">{{ item.label }}</span>
        </div>
      </div>
      <div class="btn-more" v-if="value.showMore">更多内容 ></div>
    </div>
    <div class="box-list" :class="[currentListCardType]">
      <ArticleCardList :card-type="currentListCardType" :list="postGroup[activeTab]" />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, InjectReactive, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import Controller from 'beans-admin-plugin/components/page-creator/controller';
import { getStyle } from 'beans-admin-plugin/components/page-creator/helper';
import ArticleCardList from './article-card-list.vue';

@Component({
  components: {
    ArticleCardList
  }
})
export default class PageCreateArticleTab extends Vue {
  @Prop(Object) value;
  @InjectReactive() pageWidth;
  postGroup = [];

  activeTab = 0;

  static defaultValue = {
    style: {
      marginTop: 7,
      marginBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: '#fff'
    },
    showMore: true,
    tabs: [
      {
        label: '文章'
      },
      {
        label: '专栏'
      }
    ]
  }

  static Controller = {
    functional: true,
    render(h, context) {
      const configColumns = [
        {
          prop: 'tabs',
          label: '文章分组',
          renderCell: {
            component: 'nestForm',
            props: {
              columns: [
                {
                  prop: 'label',
                  label: '分组名',
                  renderCell: 'input'
                },
                {
                  prop: 'cardType',
                  label: '卡片样式',
                  renderCell: {
                    component: 'select',
                    props: {
                      options: [
                        { label: '大图卡片', value: 'common' },
                        { label: '缩略图卡片', value: 'sm' },
                      ]
                    }
                  }
                },
                {
                  prop: 'value',
                  label: '选择自定义文章列表',
                  renderCell: {
                    component: 'select',
                    props: {
                      options: context.props.customPostLists.map(item => ({ value: item.id, label: item.title }))
                    }
                  }
                }
              ]
            }
          }
        },
        {
          prop: 'showMore',
          label: '显示查看更多',
          renderCell: 'switch'
        }
      ];
      const styleColumns = [
        {
          prop: 'marginTop',
          label: '上间距',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'marginBottom',
          label: '下间距',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'paddingLeft',
          label: '左间距',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'paddingRight',
          label: '右间距',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'backgroundColor',
          label: '背景色',
          renderCell: {
            component: 'colorPicker',
            props: {
              'show-alpha': true
            }
          }
        },
      ];
      return (
        <Controller
          {...context.data}
          configColumns={configColumns}
          styleColumns={styleColumns}
          animation
        />
      );
    }
  }

  get currentListCardType() {
    return _.get(this.value, `tabs.${this.activeTab}.cardType`);
  }

  get componentStyle() {
    return getStyle(_.get(this, 'value.style') || {}, this.pageWidth);
  }

  handleToggleTab(index) {
    this.activeTab = index;
  }

  get tabValues() {
    return (this.value.tabs || []).map(item => item.value).filter(Boolean).join(',');
  }

  @Watch('tabValues', { immediate: true })
  async onTabChange(val) {
    const ids = val.split(',');
    if (ids.length) {
      const res = await Promise.all(ids.map(id => this.$request.get(`/custom_post_lists/${id}`)))
      this.postGroup = res.map(item => item.posts);
    }
  }
}

</script>

<style scoped lang="scss">
  $primary: #4abce5;
  $text-color: #000;
  $text-color-secondary: #999999;

 .article-tab {
    background: #fff;
  }

  .box-header {
    display: flex;
    align-items: center;
    height: 60px;
    background-color: #fff;

    .btn-more {
      font-size: 13px;
      color: #999999;
      margin-left: auto;
    }
  }

  .box-tabbar {
    display: flex;

    .item {
      text-align: center;
      margin-right: 45px;
      font-size: 14px;

      .name {
        display: inline-flex;
        align-items: center;
        height: 100%;
        color: $text-color-secondary;
        transition: all .3s;
      }

      &.active {
        font-size: 18px;

        .name {
          position: relative;
          font-weight: bold;
          color: $text-color;

          &:after {
            position: absolute;
            bottom: -6px;
            left: 50%;
            width: 34px;
            height: 3px;
            border-radius: 2px;
            background: linear-gradient(90deg, #65cee3 0%, #45b9e6 100%);
            transform: translateX(-50%);
            content: '';
          }
        }
      }
    }
  }

  .box-list {
    background-color: #fff;

    &.common {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  .box-loading {
    padding: 15px;
  }
</style>

